import content from '../generated/content.json';

export const competences = content.competences || [];
